import { accountService, NizzaAccount, PrivateNizzaAccount } from '../core';

export async function getAccount(
  name: string,
  authToken?: string,
): Promise<NizzaAccount | PrivateNizzaAccount> {
  return accountService.get(name, authToken);
}
